import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Message } from 'view-design'

const state = {
  ...restful.states('category'),
  all_categories: [],
  targetSyncId: null
}

const getters = {
  ...restful.getters('category'),
  all_categories: (state) => state.all_categories
}

const actions = {
  ...restful.actions('categories'),
  async allCategory ({ commit }) {
    const res = await axios.get('categories?per=10000')
    commit('all_categories', res.data)
  },
  async syncToSubShop ({ commit, state }, id) {
    await axios.post(`categories/${state.targetSyncId}/sync_to_sub_shop`, {
      target_shop_id: id
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
  async syncToSubShops ({ commit, state }, ids) {
    await axios.post(`categories/${state.targetSyncId}/sync_to_sub_shops`, {
      target_shop_ids: ids
    })
    Message.success(i18n.t('store_modules_banner_1315'))
  },
}

const mutations = {
  ...restful.mutations('category'),
  all_categories (state, all_categories) {
    state.all_categories = all_categories
  },
  targetSyncId (state, targetSyncId) {
    state.targetSyncId = targetSyncId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
